import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UpdateConfigComponent } from './update-config/update-config.component';
import { SiteslistComponent } from './siteslist.component';



const customerRoutes: Routes = [{
    path: 'customers/:id', component: SiteslistComponent,
    children:
        [{ path: ':id', component: UpdateConfigComponent }],
},
];

@NgModule({
    imports: [RouterModule.forChild(customerRoutes)],
    exports: [RouterModule]
})
export class SitelistRoutingModule { }

